import React from 'react';
import { useTranslation } from 'react-i18next';

export default function FooterBanner({ compact = false }) {
  const { t } = useTranslation();
  const phone = t('easyCredit.footer.phoneNumber');
  const questions = t('easyCredit.footer.questions', 'Fragen zur Zahlung? Wir sind für Sie da:');
  const hours = t('easyCredit.footer.availablityTimes', 'Montag bis Freitag, 8 bis 18 Uhr');

  if (compact) {
    return (
      <div
        className="border-t border-gray-300 mx-4 py-3 text-sm text-center flex flex-col md:flex-row md:items-center md:justify-center gap-1 md:gap-3"
        data-testid="footer-compact"
      >
        <span className="font-bold">{questions}</span>
        {phone && (
          <a href={`tel:${phone.replace(/\s+/g, '')}`} className="font-bold text-primary">
            {phone}
          </a>
        )}
        <span className="text-gray-600">{hours}</span>
      </div>
    );
  }

  return (
    <div className="border-t border-gray-300 text-center mx-4 py-8">
      <p className="font-bold">{questions}</p>
      <div className="text-xl">{phone}</div>
      {hours}
    </div>
  );
}
